export function sentenceCaseFactLabel(label: string): string {
    return label.charAt(1) && label.charAt(1) === label.charAt(1).toUpperCase()
        ? label
        : label.charAt(0).toLowerCase() + label.slice(1);
}
